module.exports = __webpack_public_path__ + "img/4-3.0bf5dde2.webp";